import React from 'react';
import {connect} from 'react-redux';
import * as pcActions from '../product-configurator/actions';
import * as pcSelectors from '../product-configurator/selectors';
import * as a from './actions';
import {Loading} from '../../components/loading/views';
import * as r from 'ramda';

export const ProductConfiguratorLoginModal = connect(
    (state, ownProps) => ({
        isNamingProduct: pcSelectors.isNamingProduct(state),
    }),
    (dispatch, ownProps) => ({
        closeModal: () => {
            dispatch(pcActions.stopNamingProduct());
        },
    })
)(
    ({
        texts: {heading, subheading, cancel, login},
        closeModal,
        isNamingProduct,
        loginUrl,
    }) => {
        if (!isNamingProduct) {
            return null;
        }

        return (
            <div className="modal modal--custom modal--active">
                <div className="modal-content">
                    <h3 className="login__heading mt-4">{heading}</h3>
                    <div className="login__subheading mb-12">{subheading}</div>
                    <div className="login__footer">
                        <button
                            type="button"
                            className="btn btn--primary"
                            onClick={closeModal}
                        >
                            {cancel}
                        </button>
                        <a
                            href={loginUrl}
                            type="button"
                            className="btn btn--primary ml-auto"
                            data-btn-toggle-login
                        >
                            {login}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
);

export const ProductConfiguratorNameModal = connect(
    (state, ownProps) => ({
        namedProduct: pcSelectors.namedProduct(state),
        isNamingProduct: pcSelectors.isNamingProduct(state),
    }),
    (dispatch, ownProps) => ({
        updateName: e => {
            dispatch(pcActions.updateName(e.currentTarget.value));
        },
        nameProduct: () => {
            dispatch(a.nameProduct());
        },
        closeModal: () => {
            dispatch(pcActions.stopNamingProduct());
            dispatch(pcActions.updateName(''));
        },
    })
)(
    ({
        texts: {heading, subheading, cancel, save, placeholder},
        updateName,
        namedProduct,
        closeModal,
        nameProduct,
        isNamingProduct,
    }) => {
        if (!isNamingProduct) {
            return null;
        }

        const additionalButtonOptions =
            namedProduct.name.length > 0 ? {} : {disabled: 'disabled'};

        return (
            <div className="modal modal--custom modal--active">
                <div className="modal-content">
                    <Loading ns="productConfigurator" id="name" />
                    <h3 className="login__heading mt-4">{heading}</h3>
                    <div className="login__subheading mb-12">{subheading}</div>
                    <div className="field mb-12">
                        <input
                            type="text"
                            placeholder={placeholder}
                            className="text-center"
                            onChange={updateName}
                        />
                        {r.addIndex(r.map)(
                            (error, i) => (
                                <span key={i} className="error">
                                    {error}
                                </span>
                            ),
                            namedProduct.errors
                        )}
                    </div>
                    <div className="login__footer">
                        <button
                            type="button"
                            onClick={closeModal}
                            className="btn btn--primary"
                        >
                            {cancel}
                        </button>
                        <button
                            type="button"
                            onClick={nameProduct}
                            className="btn btn--primary ml-auto"
                            {...additionalButtonOptions}
                        >
                            {save}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
);
